// The separator is the first comma outside quoted EXTINF attributes.
function splitInfo(line) {
    let quote = null;
    for (let i = 8; i < line.length; i += 1) {
        const char = line[i];
        if (quote) {
            if (char === quote) quote = null;
        } else if (char === '"' || char === "'") {
            quote = char;
        } else if (char === ',') {
            return [line.slice(8, i), line.slice(i + 1).trim()];
        }
    }
    return [line.slice(8), ''];
}

export function parseM3UtoJSON(m3u) {
    const lines = m3u.replace(/^\uFEFF/, '').split(/\r\n|\r|\n/);
    const channelsByGroup = {};
    let currentChannel = null;
    for (const rawLine of lines) {
        const line = rawLine.trim();
        if (/^#EXTINF:/i.test(line)) {
            const [metadata, trailingName] = splitInfo(line);
            const attrs = Object.create(null);
            const pattern = /([\w-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"']+))/g;
            for (const match of metadata.matchAll(pattern)) {
                attrs[match[1].toLowerCase()] = (match[2] ?? match[3] ?? match[4]).trim();
            }
            currentChannel = {
                tvgId: attrs['tvg-id'] || '',
                tvgName: attrs['tvg-name'] || '',
                tvgLogo: attrs['tvg-logo'] || '',
                groupTitle: attrs['group-title'] || '',
                name: attrs['tvg-name'] || trailingName
            };
        } else if (/^#EXTGRP:/i.test(line)) {
            if (currentChannel && !currentChannel.groupTitle) {
                currentChannel.groupTitle = line.slice(8).trim();
            }
        } else if (line && !line.startsWith('#') && currentChannel) {
            currentChannel.url = line;
            currentChannel.groupTitle ||= 'Undefined';
            const group = currentChannel.groupTitle;
            // Provider categories may be named "constructor" or "__proto__".
            if (!Object.prototype.hasOwnProperty.call(channelsByGroup, group)) {
                Object.defineProperty(channelsByGroup, group, {
                    value: [], enumerable: true, configurable: true, writable: true
                });
            }
            channelsByGroup[group].push(currentChannel);
            currentChannel = null;
        }
    }
    return channelsByGroup;
}
